import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { errorMessage } from "../lib/helper";
import { setImageSearchData, setImageSearchError } from "../redux/homepage";

export const searchImageResult = async (keyword, size, showPerPage, sortBy) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getImagesSearchList
        }?keyword=${keyword?.trim()}&size=${size}&page=${showPerPage}${sortBy ? `&sortBy=${sortBy}` : ""
        }`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const searchExclusiveImageResult = async (
  keyword,
  size,
  showPerPage,
  sortBy
) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getExclusiveImagesSearchList
        }?keyword=${keyword?.trim()}&size=${size}&page=${showPerPage}${sortBy ? `&sortBy=${sortBy}` : ""
        }`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const searchImageByName = async (keywords) => {
  if (keywords !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.imagesearchByName}?keywords=${keywords?.trim()}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};
export const ExclusivesearchImageByName = async (keywords) => {
  if (keywords !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.ExclusiveimagesearchByName}?keywords=${keywords?.trim()}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};
export const autosuggest = async (keyword) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.autosuggest}?keyword=${keyword}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response.data?.data;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const AddSearchLogs = async (payload) => {
  if (payload !== undefined) {
    try {
      const response = await axios.post(`${ApiConfig.searchLogs}`, payload);
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response.data?.data;
      }
    } catch (e) {
      return e;
    }
  }
};

export const searchVideoResult = async (keyword, size, showPerPage) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getVideoSearchResults}?keyword=${keyword}&size=${size}&page=${showPerPage}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const searchVideosByName = async (keywords) => {
  if (keywords !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getVideoSearchByName}?keywords=${keywords?.trim()}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const searchStarsCollection = async (
  keyword,
  size,
  showPerPage,
  sortBy
) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getStarsCollectionSearchList
        }?keyword=${keyword?.trim()}&size=${size}&page=${showPerPage}${sortBy ? `&sortBy=${sortBy}` : ""
        }`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const searchStarCollectionByName = async (keywords) => {
  if (keywords !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getStarCollectionSearchByName
        }?keywords=${keywords?.trim()}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};


export const uploadImages  = async (formData) => {
  try {
    const resp = await axios.post(`${ApiConfig.uploadSearchImage}`, formData);
    console.log(resp,"resp in upload")
    if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
      return resp.data
    } else {
      console.log("throw resp");
      throw resp
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
  }
};

export const ImageSearchAfterUpload = (formData) => {
  return async (dispatch) => {
    try {
      const resp = await axios.post(`${ApiConfig.uploadSearchImage}`, formData);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setImageSearchData(resp?.data?.hits));
        return true;
      } else {
        throw new Error(`Error: ${resp?.status}`);
      }
    } catch (e) {
      if (e.response) {
        console.error("Error response data:", e.response.data);
      }
      dispatch(
        setImageSearchError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  };
};

// export const ImageSearchAfterUpload = (formData) => {
//   return async (dispatch) => {
//     try {
//       // dispatch(setLoading(true));
//       console.log("gng n cnsl");
//     const resp = await axios.post(`${ApiConfig.uploadSearchImage}`, formData);
//     console.log("data::",resp,resp?.data?.status,resp?.data,resp?.data?.data?.hits)
//       if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
//         dispatch(setImageSearchData(resp?.data?.hits));
//         console.log(resp?.data?.hits);
//         // dispatch(setLoading(false));
//         return true;
//       } else {
//         console.log("else is executing");
//         throw resp;
//       }
//     } catch (e) {
//       console.log("error::",e)
//       dispatch(
//         setImageSearchError({
//           isError: true,
//           message: errorMessage(e),
//         })
        
//       );
//       console.log("Error::",e)
//       toast.error(errorMessage(e), {
//         autoClose: 2500,
//       });
//       return false;
//       // dispatch(setLoading(false));
//     }
//   };
// };